import { billingService } from '@/services/billingService';
import { toast } from '@/components/ui/sonner';

// Map subscription numbers to plan names
const subscriptionNumberToPlan: Record<string, string> = {
  '1': 'Free',
  '2': 'Startup', 
  '3': 'Growth',
  '4': 'Plus',
  '5': 'Scale'
};

/**
 * Handles subscription upgrade based on the selected subscription number stored in localStorage
 */
export const handleSubscriptionUpgrade = async () => {
  const selectedSubscription = localStorage.getItem('selected-subscription');
  
  if (!selectedSubscription) {
    return; // No subscription upgrade requested
  }
  
  const planName = subscriptionNumberToPlan[selectedSubscription];
  if (!planName) {
    console.error('Invalid subscription number:', selectedSubscription);
    return;
  }
  
  // Don't upgrade if it's the Free plan
  if (planName === 'Free') {
    localStorage.removeItem('selected-subscription');
    return;
  }
  
  try {
    // Get all plans to find the correct one
    const plans = await billingService.getPlans();
    const targetPlan = plans.find(plan => plan.name === planName);
    
    if (!targetPlan) {
      console.error('Plan not found:', planName);
      toast.error(`Plan "${planName}" not found. Please try again later.`);
      return;
    }
    
    // Create checkout session for the upgrade
    const response = await billingService.createCheckoutSession(targetPlan.price.id, true);
    
    if (response && response.url) {
      // Clear the selected subscription from localStorage
      localStorage.removeItem('selected-subscription');
      
      // Redirect to Stripe Checkout
      window.location.href = response.url;
    } else {
      toast.error('Failed to create checkout session');
    }
  } catch (error) {
    console.error('Error creating checkout session:', error);
    toast.error(error instanceof Error ? error.message : 'Failed to create checkout session');
  }
}; 